export default __webpack_public_path__ + "static/media/buildings.a31706f5.svg";